require('./brokerETFBuySuccess.scss');
require('./brokerETFBuySuccess.override.scss');

const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { formatText, FormattedText } = require('core/i18n').i18n;

// @commons
const { OKMessage } = require('commonsComponents/OKMessage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const StocksBuySellSummary = require('components/broker/commons/stocksBuySellSummary/stocksBuySellSummary');

// @helpers
const {
    FIRST_STEP,
    SECOND_STEP,
    BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER,
    TYPE_ETFS,
    MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL
} = require('constants/index');


const BrokerETFBuySuccess = props => {
    const { productFile, immETFBuy, immStocksContracts } = props;
    const orderNumber = immETFBuy.getIn(['orderConfirmation', 'orderNumber']);
    const successMessage = formatText('broker-etfBuySuccessStepMessage');
    const successSubMessage = formatText('broker-etfBuySuccessStepSubMessage', [orderNumber]);
    const mainButtonLabel = formatText('broker-etfBuySuccessStepBackToWalletButtonLabel');
    const secondaryButtonLabel = formatText('stocksContract-reviewOrders');
    const step1 = immETFBuy.get('steps').get(FIRST_STEP);
    const step2 = immETFBuy.get('steps').get(SECOND_STEP);
    const stocksContractSelectedValue = immETFBuy.getIn([
        'steps',
        FIRST_STEP,
        'stocksContractSelectedValue'
    ]);
    const stockContract = immStocksContracts.get(stocksContractSelectedValue);
    const productCurrency = productFile.get('currency');

    return (
        <WizardSuccess
            successMessage={successMessage}
            successSubMessage={successSubMessage}
            customClassName="etfs-buy-success"
            mainButton={{ label: mainButtonLabel, url: '/myprofile/broker' }}
            secondaryButton={{ label: secondaryButtonLabel, url: MYPROFILE_BROKER_ORDERSANDMOVEMENTS_URL }}
        >
            <StocksBuySellSummary
                productName={formatText('broker-etfSummaryProductName')}
                productCurrency={productCurrency}
                stockContract={stockContract}
                stockDescription={productFile.get('companyName')}
                productIso={productFile.get('micCode')}
                productType={TYPE_ETFS}
                step1={step1}
                step2={step2}
                modifier={BROKER_STOCKS_BUY_SELL_SUMMARY_BUY_MODIFIER}
                titlesQuantityTitle="stocksBuySellSummaryTitlesQuantityParticipations"
            />
            <OKMessage type="informative">
                <FormattedText value="broker-buyETFLegalTextMessage" />
            </OKMessage>
        </WizardSuccess>
    );
};

BrokerETFBuySuccess.propTypes = {
    productFile: PropTypes.object.isRequired,
    immETFBuy: PropTypes.object.isRequired,
    immStocksContracts: PropTypes.object.isRequired
};

module.exports = BrokerETFBuySuccess;
